import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { setReport } from '../store/actions/auth';
import { toast } from "react-toastify";
class SignOut extends Component {
  componentWillMount(){
    const { setReport } = this.props;
    let user = JSON.parse(localStorage.getItem('user')); 
    if(user && user.id){
      let report = {
       "UserId": user.id,
       "Event": "Logout"
       }
      setReport(report)
    }
  }
  render() {
    localStorage.removeItem('userId');
    localStorage.setItem("isSignedOut", true);
    localStorage.setItem('sessionTimeOut', 'true');
    localStorage.removeItem('auth');
    localStorage.removeItem('user');
    localStorage.removeItem('persist:root');
    localStorage.removeItem('IsHomerNavigatFromFeedBackTemplate');
    if(localStorage.getItem("isAnnotationImageUpload")==='true'){
      localStorage.removeItem("isAnnotationImageUpload");
      toast.error(" 🚫There seems to be some problem with the low memory, unable to process the request now.", {
        autoClose: 12000,
        position: "top-center",
      });
      return false;
    }
    else{
      return (
        <Redirect to={"/auth/sign-in"} />
      );
    }
   
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  setReport:setReport

},dispatch);

export default connect(null,mapDispatchToProps)(SignOut);
